// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__7exq-","outlet":"Dashboard_outlet__APoqI","native":"Dashboard_native__69mtV"};